import React, { memo } from "react";
import { Box, Flex, Text, Highlight, Container, VStack } from "@chakra-ui/react";
import { listHowData } from "@/constants/alohainfo-contants";
export default memo(function HowComponent() {
   return (
      <Flex
         flexDir={"column"}
         alignItems={"center"} 
         mx={"auto"}
         w={{ base: "90%", BREAK_PAD: "740px", BREAK_LPC: "960px", BREAK_PC: "1280px" }}
         pt={{ base: "50px",BREAK_PAD:'85px', BREAK_LPC: "120px" }}
         pb={{ base: "40px", BREAK_PAD:'80px',BREAK_LPC: "120px" }}
         mt={{ base: "60px",BREAK_PAD:'90px', BREAK_LPC: "120px" }}
         bg={"#F5FAFC"}
         borderRadius={"20px"}>
         <Container maxW={{ base: "90%", BREAK_PAD: "80%", BREAK_LPC: "70%" }} p={'0px'}>
            <Text
               fontSize={{ base: 24, BREAK_LPC: 34 }}
               fontFamily={{ base: "Arial-BoldMT", BREAK_LPC: "Arial" }}
               textAlign="center">
               <Highlight query="How" styles={{ color: "green.500" }}>
                  How does AlohaBots go beyond your expectations?
               </Highlight>
            </Text>
            <VStack spacing={{base:'24px',BREAK_LPC:'50px'}}  flexDir={"column"} mt={{ base: "33px", BREAK_LPC: "69px" }} >
               {listHowData.map((item, index) => {
                  return (
                     <Flex w={'full'} flexDir={"row"}  key={item} >
                        <Box>
                           <Text
                              fontSize={{ base: 18, BREAK_LPC: 24 }}
                              w={{ base: "36px", BREAK_LPC: "62px" }}
                              h={{ base: "36px", BREAK_LPC: "62px" }}
                              bg={"white"}
                              borderRadius={"full"}
                              lineHeight={{ base: "36px", BREAK_LPC: "62px" }}
                              textAlign="center"
                              fontFamily={"Arial-BoldMT"}
                              color={"green.500"}>
                              0{index + 1}
                           </Text>
                        </Box>
                        <Text
                           fontSize={{ base: 16, BREAK_LPC: 20 }}
                           color={"#333"}
                           my={'auto'}
                           ml={{base:'10px',BREAK_LPC:'32px'}}>
                           {item}
                        </Text>
                     </Flex>
                  );
               })}
            </VStack>
         </Container>
      </Flex>
   );
});
